import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./Redux/Store/Store";
import { GoogleOAuthProvider } from "@react-oauth/google";
const clientId = `93040314372-3mpm89spbkd6tv8e7qa52hjmide66mf9.apps.googleusercontent.com`;
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId={clientId}>
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  </GoogleOAuthProvider>
);
